import { createSlice } from '@reduxjs/toolkit';
import type { RootState } from 'state/store';

export const initialState: string = '';

export const slice = createSlice({
  name: 'postcode',
  initialState,
  reducers: {
    setInitialState: () => initialState,
    setPostcode: (state, { payload }) => payload
  }
});

export const { setPostcode, setInitialState } = slice.actions;

export const selectPostcode = (state: RootState) => state[slice.name];

export default slice.reducer;
